import(/* webpackMode: "eager", webpackExports: ["Client"] */ "/app/apps/topshop/app/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageLoadAnalytics"] */ "/app/apps/topshop/components/analytics/page-load-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/apps/topshop/components/footer/footer.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/topshop/components/nav/nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SecureScriptContainerClient"] */ "/app/apps/topshop/components/secure-script-container/secure-script-container-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/topshop/theme/topshop-2/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../theme/fonts/Relative-Black-Pro.woff2\",\"weight\":\"900\"},{\"path\":\"../theme/fonts/Relative-Bold-Pro.woff2\",\"weight\":\"700\"},{\"path\":\"../theme/fonts/Relative-Book-Pro.woff2\",\"weight\":\"400\"}],\"variable\":\"--font-family-relative-pro\"}],\"variableName\":\"relativePro\"}");
